import React from 'react';
import PropTypes from 'prop-types';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import classNames from 'classnames';
import './Modal.scss';

const ModalComponent = ({
  isVisible,
  overlayClosesModal,
  isCloseButtonShown,
  closeModal,
  child,
  customContentClass,
}) => {
  if (isVisible) {
    const childBody = (typeof child === 'function' ?  child() : child);
    const contentClasses = classNames('modal-content', { [customContentClass]: Boolean(customContentClass), });
    return (
      <ReactCSSTransitionGroup transitionName="modal" transitionEnterTimeout={700} transitionLeaveTimeout={700}>
        <div className="modal-container">
          <div className={contentClasses}>
            {isCloseButtonShown && <i onClick={closeModal} className="material-icons modal-close-button">close</i>}
            <div className="modal-body">{childBody}</div>
          </div>
          <a className="modal-overlay" onClick={overlayClosesModal && closeModal} />
        </div>
      </ReactCSSTransitionGroup>
    );
  }
  return <ReactCSSTransitionGroup transitionName="modal" transitionEnterTimeout={0} transitionLeaveTimeout={0} />;
};

ModalComponent.propTypes = {
  isVisible: PropTypes.bool,
  overlayClosesModal: PropTypes.bool,
  isCloseButtonShown: PropTypes.bool,
  closeModal: PropTypes.func,
  child: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
  customContentClass: PropTypes.string,
};

ModalComponent.defaultProps = {
  isVisible: null,
  overlayClosesModal: true,
  isCloseButtonShown: true,
  closeModal: null,
  child: null,
  customContentClass: '',
};

export default ModalComponent;
